import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_ReleaseOfInformationForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_ReleaseOfInformationForm' className='file-pdf-document'>

            <div className='file-template'>

                <p>
                    <input type="checkbox" name="cbName" id="cbName" className='add-only' value="Name" />
                    I hereby authorize the disclosure of records/information
                </p>
                <p>
                    From: <input type="text" name="txtName1" id="txtName1" className='add-only w-450 custom-add-only' placeholder='(Name of health care provider holding the information - releasing agency)'/>
                    
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span>
                            <input type="text" name="txtAddress" id="txtAddress" className='add-only' placeholder="Address" />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone/Fax:</span>
                            <input type="text" name="txtPhone" id="txtPhone" className='add-only' placeholder="Phone/Fax" />
                        </td>
                    </tr>
                </table>
                <p>
                    To:
                    <input type="text" name="txtName2" id="txtName2" className='add-only w-450 custom-add-only' placeholder="(Name of Person or Agency to whom information should be given - requesting agency)" />
                    
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span>
                            <input type="text" name="txtAddress1" id="txtAddress1" className='add-only' placeholder="Address" />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone/Fax:</span>
                            <input type="text" name="txtPhone1" id="txtPhone1" className='add-only' placeholder="Phone/Fax" />
                        </td>
                    </tr>
                </table>
                <p>
                    <input type="checkbox" name="cbMyRecords" id="cbMyRecords" className='add-only' value="I authorize the following information from my records (and any specific portion thereof):" />
                    I authorize the following information from my records (and any specific portion thereof):
                    <textarea name="txtMyRecords" id="txtMyRecords" className='add-only'></textarea>
                </p>
                <p>
                    <input type="checkbox" name="cbDrugAbuse" id="cbDrugAbuse" className='add-only' value="I authorize the disclosure of alcohol or drug abuse information, if any. (Please see paragraph 2 below)" />
                    I authorize the disclosure of alcohol or drug abuse information, if any. (Please see paragraph 2 below)
                </p>
                <p>
                    <input type="checkbox" name="cbRelatedConditions" id="cbRelatedConditions" className='add-only' value="I authorize the disclosure of information, if any, concerning testing for HIV (human immunodeficiency virus)" />
                    I authorize the disclosure of information, if any, concerning testing for HIV (human immunodeficiency virus)
                    and/or treatment for HIV or AIDS (acquired immune deficiency syndrome) and any related conditions.)
                </p>
                <p>
                    The above information is for the purpose of:
                    <textarea name="txtAboveInformation" id="txtAboveInformation" className='add-only'></textarea>
                </p>
                <ol typeof="1">
                    <li>I understand that the information disclosed pursuant to this Authorization may be subject to re-disclosure by the recipient and
                        no longer protected by federal privacy regulation of other applicable state or federal laws (except as set forth in paragraph 2
                        below).
                    </li>
                    <li>I understand that pursuant to 42 C.F.R Part 2, alcohol and drug abuse records that I authorize to be disclosed pursuant to
                        this document may not be further redisclosed without my written consent, except by a court order that complies with the
                        preconditions set forth at 42 C.F.R. 2.61 et seq., or the other limited circumstance specifically permitted by 42 C.F.R Part 2.
                        Any individual that makes such a disclosure in violation of these provision may be reported to the United States Attorney and
                        be subjected to criminal penalties.
                    </li>
                    <li>I understand that the Department or my health care provider will not condition my treatment, payment or eligibility for any
                        applicable benefits on whether I provide authorization for the requested release of information.
                    </li>
                    <li>I intend this document to be a valid authorization conforming to all requirements of the Privacy Rule and State Law, and
                        understand that my authorization will remain in effect for: (PLEASE CHECK ONE)
                    </li>
                </ol>
                <p>
                    <input type="checkbox" name="cb1Year" id="cb1Year" className='add-only' value="One (1) year OR" /> One (1) year OR &nbsp;
                    <input type="checkbox" name="cbAllTransactions" id="cbAllTransactions" className='add-only' value="the period necessary to complete all transactions on matters related to services provided to me." /> the period necessary to complete all transactions on matters related to services provided to me.
                </p>
                <p>
                    I understand that unless otherwise limited by state or federal regulation, and except to the extent that action has been taken based
                    upon it, I may revoke this authorization at any time as shown in the space below.
                </p>
                <table>
                    <tr>
                        <td className='signature w-450'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-'>Signature of Individual</td>
                        <td className='small w-'>Print Name</td>
                        <td className='small w-'>Date</td>
                    </tr>
                </table>
                <p>
                    OR Signature of other person authorized to sign for individual
                </p>
                <p>
                    <span className='small'>(check one):</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbCourt" id="cbCourt" className='add-only' value="Court-appointed Custodian of Minor" />
                            Court-appointed Custodian of Minor
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbAdvanceDirective" id="cbAdvanceDirective" className='add-only' value="Agent designated by Individual Advance Directive" />
                            Agent designated by Individual Advance Directive
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" name="cbParent" id="cbParent" className='add-only' value="Parent" />
                            Parent
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" name="cbGuardian" id="cbGuardian" className='add-only' value="Guardian" />
                            Guardian
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-450'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Signature of other person authorized to sign for individual</td>
                        <td className='small w-150'>Print Name</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                        <td className='signature w-100'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Signature of Witness</td>
                        <td className='small w-250'>Title</td>
                        <td className='small w-150'>Print Name</td>
                        <td className='small w-100'>Date</td>
                    </tr>
                </table>
                <p>
                    <strong>USE THIS SPACE ONLY IF AUTHORIZATION IS WITHDRAWN</strong>
                </p>
                <p>
                    I hear by revoke this authorization, and will send written notice of my withdrawal of this authorization to the staff of the healthcare
                    provider who is providing services to me.
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp;</td>
                        <td className='signature w-375'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Date tis authorization is revoked</td>
                        <td className='small w-375'>Signature of individual or Legally Authorized Representative</td>
                    </tr>
                </table>


            </div>
        </form>

    )
} 
